import { Fragment } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Switch } from "react-router-dom";
import Logo from "../../../Logo";
import Route from "../../../Route";
import LinkWrap from "../../../LinkWrap/component";
import LandingNav from "../LandingNav/component";
import TertiaryNav from "../TertiaryNav/component";
import VideoChannelsNav from "../VideoChannelsNav/component";
import { SUB_NAV_LIST } from "../../constants";
import { getTertiaryNavList } from "./library";
import classNames from "classnames";
import { BASESECTION_OVERWRITES } from "../../constants";
import { normalizeClass } from "../../../../utils/path/library";
import { SECTIONS } from "../../../../constants/sections";
import {
    getRegionalPath,
    normalizeRegionUrl,
} from "../../../../utils/path/library";
import ShortcutsBar from "../../../ShortcutsBar";
import ElectionsBar from "../../../ElectionsBar/component";

const SecondaryNav = ({
    viewport = "",
    isDetail = false,
    menuOpen = false,
}) => {
    const baseNavSection = useSelector((state) => state.app.baseNavSection);
    const subSection = useSelector((state) => state.app.subSection);
    const path = useSelector((state) => state.app.path);
    const contentId = useSelector((state) => state.app.contentId);

    /**
     * Render the section link with the Gem icon, e.g. Sports, News, Arts etc
     * @returns {jsx}
     */
    const getGemSubsectionLink = () => {
        const key = `gem-${baseNavSection}`;
        const regionObj = subSection ? getRegionalPath(path) : null;
        const regionName = regionObj ? regionObj.title : "";

        let iconSection = SECTIONS[baseNavSection] ? baseNavSection : null;
        let iconTitle = baseNavSection;

        if (regionName) {
            iconTitle = regionName;
            iconSection = regionName;

            //replacing to access dictionary using the region name. This will be refactored shortly in WEBX-835
            iconSection = iconSection
                .replace(" & ", "")
                .replace(/ /g, "")
                .replace("-", "");
        } else if (SECTIONS[baseNavSection] && SECTIONS[baseNavSection].title) {
            iconTitle = SECTIONS[baseNavSection].title;
        }

        const baseSectionCheck = BASESECTION_OVERWRITES[baseNavSection];
        const baseSectionUrl = baseSectionCheck
            ? `/${baseSectionCheck}`
            : `/${baseNavSection}`;
        const sectionUrl = regionName
            ? normalizeRegionUrl(path, baseSectionUrl)
            : baseSectionUrl;
        const subSectionClass = isDetail ? "" : subSection; // don't pass the subsection in on a detail page (because it might be a title)
        const sectionLogoProps = {
            className: classNames(
                "subSectionLogo",
                baseNavSection,
                subSectionClass
            ),
            section: iconSection,
            title: iconTitle,
        };

        const regionClassName = regionName
            ? normalizeClass("region", regionName)
            : "";
        const linkClasses = classNames("navLink subNavLink", regionClassName, {
            regionName: regionName,
        });

        return (
            <div key={key} className="gemSectionLink" id="section-link-title">
                <LinkWrap
                    className={linkClasses}
                    key={`${key}-link`}
                    url={sectionUrl}
                    external={false}
                >
                    <span className="a11y">{iconTitle}</span>
                    <Logo {...sectionLogoProps} />
                </LinkWrap>
            </div>
        );
    };

    const renderLandingNav = () => {
        // Special case where producer wants TV for navigation label but television for path
        const landingBaseNavSection =
            baseNavSection.indexOf("television") > -1 ? "tv" : baseNavSection;

        if (SUB_NAV_LIST[landingBaseNavSection] !== undefined) {
            return (
                <LandingNav
                    baseNavSection={landingBaseNavSection}
                    subSection={subSection}
                    path={path}
                    viewport={viewport}
                    isDetail={isDetail}
                    gemDepartment={getGemSubsectionLink()}
                    regionObject={getRegionalPath(path)}
                    hasTertiaryNav={getTertiaryNavList(path) !== null}
                />
            );
        }
        return null;
    };

    const renderTertiaryNav = () => {
        if (getTertiaryNavList(path)) {
            return (
                <TertiaryNav
                    baseNavSection={baseNavSection}
                    subSection={subSection}
                    path={path}
                    items={getTertiaryNavList(path)}
                    viewport={viewport}
                    contentId={contentId}
                />
            );
        }
        return null;
    };

    return (
        <Fragment>
            {!menuOpen && <ShortcutsBar />}
            {renderLandingNav()}
            {renderTertiaryNav()}
            {!menuOpen && <ElectionsBar />}
            <Switch>
                <Route path="/player" component={VideoChannelsNav} />
            </Switch>
        </Fragment>
    );
};

SecondaryNav.propTypes = {
    viewport: PropTypes.string,
    isDetail: PropTypes.bool,
};

export default SecondaryNav;
